<template>
<div>
  <!-- <ef-header>
  </ef-header> -->

  <body>
    <section  class="sponsor-block">
      <div class="container">
        <div class="inner m-auto text-center">
          <h3>404 </h3>
          <h2><br> This is not the web page you are looking for. <br><strong><a href="/">Back to Home</a>.</strong></h2>


        </div>
      </div>
    </section>
  </body>
</div>
</template>
<script>
import efHeader from "./EFHeader.vue"

export default {
    name: "NotFound",
    data: function () {
    return {
      erroeMessage: "404",
    };
  },
  components: {
    efHeader
  }
}
</script>
<style scoped>
body {font-family: 'Kanit', sans-serif;overflow-x:hidden;font-weight:normal;position: relative; padding-top:40px;}
img {vertical-align: top; max-width: 100%;}
h1 {font-size: 20px; line-height: 46px;}
h2 {font-size: 40px; line-height: 46px;}
h3{font-size: 50px; line-height: 46px; color: #5D6667;}

.site-header {background: #1C2324;position: fixed;top: 0;z-index: 999;width: 100%;left: 0;right: 0;}
.site-header .navbar-header {display: inline-block;width: 100%;}
.site-header .navbar-header .navbar-brand {color: #fff;float: left;}
.site-header .navbar-header .navbar-brand h1 {font-size: 24px;line-height: 29px;font-weight: 600;}
.site-header .inner {padding: 5px 0;}
.site-header .container {max-width: 100%;}

.container {width: 100%; max-width: 1260px; margin:auto; padding: 0 15px;}
.button {color: #fff;font-size: 22px;display: inline-block;text-align: center;text-transform: uppercase;background-color: #00a1e2;letter-spacing: -0.5px;font-weight: bold;padding: 8px 20px;border: 2px solid #00a1e2;text-decoration: none; cursor: pointer; -webkit-transition: all 0.5s ease; -moz-transition: all 0.5s ease; -o-transition: all 0.5s ease; transition: all 0.5s ease;}
.button:hover {background-color: #fff;color: #00a1e2;border-color: #fff;}
.bg-cover {background-size: cover !important; background-repeat: no-repeat !important; background-position: center center !important;}
.text-center {text-align: center;}
.m-auto {margin: auto;}

.nav-toggle {margin: 0;padding: 0;width: 30px;height: 28px; cursor: pointer;position: relative;float: right;z-index: 9; top: 2px;}
.nav-toggle i, .nav-toggle i:after, .nav-toggle i:before {background-color: #fff;position: absolute;width:22px;height: 2px;transition-timing-function: ease;transition-duration: .3s;transition-property: transform;border-radius: 5px; left: 0; right: 0; margin: auto;}
.nav-toggle i {transition-timing-function: cubic-bezier(.55,.055,.675,.19);transition-duration: 300ms;left: 0;top: 50%;display: block;margin-top: -2px;}
.nav-toggle i:after, .nav-toggle i:before {display: block;content: "";}
.nav-toggle i:before {top: -8px;transition: top 300ms ease .15s,opacity 300ms ease; left: 3px;}
.nav-toggle i:after {bottom: -8px;transition: bottom 300ms ease .15s,transform 300ms cubic-bezier(.55,.055,.675,.19); left: -7px;}

.main-menu {position: fixed;right: -220px;top: 0;width: 210px;background: #58595B;padding: 30px 25px 60px 25px;-moz-transition: 400ms ease all;-webkit-transition: 400ms ease all;transition: 400ms ease all; z-index: 9999;}
.main-menu .close-icon {text-align: right;}
.site-header .main-menu ul li {text-align: center;margin: 28px 0 0 0;}
.site-header .main-menu ul li a {color: #fff;font-size: 21px;text-transform: uppercase;}
.site-header .main-menu ul li a.active-menu {color: #75BC43;}
body.menu-open .main-menu {right: 0;}

.sponsor-block {padding: 110px 0;}
.sponsor-block .inner {max-width: 660px;}
.sponsor-block .inner .img {margin-bottom: 15px;}
.sponsor-block .inner h2 {color: #5D6667;}
.sponsor-block .inner h2 strong {font-weight: normal; color: #75BC43;}
.sponsor-block .inner h2 a { font-size: 26px; color: #75BC43;}
.sponsor-block .inner p {font-size: 28px; line-height: 32px; margin-top: -10px; color: #5D6667}



</style>
